import { createSelector } from 'reselect';

const baseCreditsSelector = (state: any) => state?.credits;

export const creditsSelector = createSelector(
    baseCreditsSelector,
    (credits) => credits,
);
